import React from 'react';
import ProductStatCard from './ProductStatCard';
import { useSelector } from 'react-redux';

function ProductStats() {
    const productsInsights = useSelector((state) => state.reportAnalysis.productsInsights.productsInsights);

    // console.log(productsInsights);

    return (
        <div className="grid grid-cols-6 gap-x-2 mx-5 mt-4">
            {
                Object.keys(productsInsights).length > 0 && 
                <>
                    <ProductStatCard 
                        statName='Total Products' 
                        statValue={productsInsights.stats.totalproducts} 
                    />
                    <ProductStatCard 
                        statName='Active Products' 
                        statValue={productsInsights.stats.activeProducts} 
                    />
                    <ProductStatCard 
                        statName='Draft Products' 
                        statValue={productsInsights.stats.draftProducts} 
                    />
                    <ProductStatCard 
                        statName='Inactive Products' 
                        statValue={productsInsights.stats.inactiveProducts} 
                    />
                    <ProductStatCard 
                        statName='Out of Stock' 
                        statValue={productsInsights.stats.outOfStockProducts}
                    />
                    <ProductStatCard 
                        statName='Inventory Stocks' 
                        statValue={productsInsights.stats.inventoryStock} 
                    />
                </>
            }
        </div>
    );
}

export default ProductStats;
